import {memo} from 'react';
import style from './style.module.scss';
import {FooterWarning} from 'modules/footer/components/Footer/Warning';
import {FooterNav} from 'modules/footer/components/Footer/Nav';
import {FooterCopyrights} from 'modules/footer/components/Footer/Copyrights';
import {FooterContacts} from 'modules/footer/components/Footer/Сontacts';
import {FooterMain} from 'modules/footer/components/Footer/Main';
import {SocialList} from 'modules/footer/components/Footer/SocialList';
import {Box} from 'components/Grid';
import {FooterLocation} from 'modules/footer/components/Footer/Location';
import classNames from 'classnames';

export const Footer = memo(() => {
    return (
        <footer id={'footer'} className={style.customFooter}>
            <FooterWarning />
            <FooterNav />
            <FooterMain />
            <Box className={classNames('d-block-only-sm', style.socialList)}>
                <SocialList />
            </Box>
            <FooterContacts isLocation={true} />
            <Box className={classNames('d-flex-only-sm', style.location)}>
                <FooterLocation />
            </Box>
            <FooterCopyrights />
        </footer>
    );
});
